// extracted by mini-css-extract-plugin
module.exports = {"container":"SearchInput_container__19awP","icon":"SearchInput_icon__14eFh","clearButton":"SearchInput_clearButton__2c8Mj"};